import { useRoutes } from "react-router-dom";
import { PublicRoutes } from "./Public";
import { Protected } from "./Protected";

export function MainRoutes() {
  const { ProtectedRoutes } = Protected();
  const element = useRoutes([...PublicRoutes, ...ProtectedRoutes]);
  return element;
}
